import { create } from 'zustand';

interface UnreadState {
  counts: Map<string, number>;
  conversations: any[];
  setUnreadCountByUniqueName: (uniqueName: string, count: number) => void;
  clearUnreadCountByUniqueName: (uniqueName: string) => void;
  getUnreadCountByUniqueName: (uniqueName: string) => number;
  setConversations: (conversations: any[]) => void;
  addConversation: (conversation: any) => void;
  removeConversation: (conversation: any) => void;
  }

export const useUnreadStore = create<UnreadState>((set, get) => ({
  counts: new Map(),
  conversations: [],
  
  setUnreadCountByUniqueName: (uniqueName: string, count: number) => {
    set((state) => {
      const newCounts = new Map(state.counts);
      newCounts.set(uniqueName, Math.max(0, count));
      return { counts: newCounts };
    });
  },
    
  clearUnreadCountByUniqueName: (uniqueName: string) => {
    set((state) => {
      const newCounts = new Map(state.counts);
      newCounts.set(uniqueName, 0);
      return { counts: newCounts };
    });
  },
  
  getUnreadCountByUniqueName: (uniqueName: string) => {
    return get().counts.get(uniqueName) ?? 0;
  },
  
  setConversations: (conversations: any[]) => {
    set({ conversations });
  },

  addConversation: (conversation: any) => {
    set((state) => ({
      conversations: [...state.conversations, conversation]
    }));
  },

  removeConversation: (conversation: any) => {
    set((state) => ({
      conversations: state.conversations.filter(conv => conv.sid !== conversation.sid)
    }));
  },
}));

